import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import { DateTimeNow, DateTranslate, Datediff, OnlyDateTranslate } from "@/app/core/util/DateTranslater";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { toast } from "react-toastify";
import { TotalExpressController } from "@/app/core/base/controllers/TotalExpressController";
import { CalculoICMS, CurrencyConverter, MoneyMask, ProcessOnlyValue, ProcessProfit, ProcessValue } from "@/app/core/util/helpers/MoneyHelper";
import { ShipSmartController } from "@/app/core/base/controllers/ShipSmartController";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import AddressStep from "./components/AddressStep";
import BoxesStep from "./components/BoxesStep";
import QuotationStep from "./components/QuotationStep";
import ConfirmationStep from "./components/ConfirmationStep";
import { ServiceNameController } from "@/app/core/base/controllers/ServiceNameController";
import { ICMSController } from "@/app/core/base/controllers/ICMSController";
import { CorreiosController } from "@/app/core/base/controllers/CorreiosController";
import { PartnerHelper } from "@/app/core/util/helpers/PartnerHelper";
import { ProfitController } from "@/app/core/base/controllers/ProfitController";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { AddressBookController } from "@/app/core/base/controllers/AddressBookController";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import { CustomMarginController } from "@/app/core/base/controllers/CustomMarginControlle";
import { HandleErrors } from "@/app/core/util/helpers/ErrorHelper";
import Functions from "@/app/core/util/Functions";
import { FedexController } from "@/app/core/base/controllers/FedexController";
import { MyDhlController } from "@/app/core/base/controllers/MyDhlController";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import InternationalAddressStep from "./components/InternationalAddressStep";

export default function Quotation(props) {
    const [step, setStep] = useState(1);
    const userData = Storage.getUserData();
    const date = new Date();
    const [data, setData] = useState({});
    const [responsibles, setResponsibles] = useState({});
    const [national, setNational] = useState([]);
    const [addressBook, setAddressBook] = useState([]);
    const [nationalCarrier, setNationalCarrier] = useState({});
    const [internationalCarrier, setInternationalCarrier] = useState({});
    const [loading, setLoading] = useState(false);
    const [international, setInternational] = useState({});
    const [ICMS, setICMS] = useState([]);
    const [profit, setProfit] = useState([]);
    const [correiosServices, setCorreiosServices] = useState([]);
    const [names, setNames] = useState([]);
    const enviroment = process.env.REACT_APP_ENV;
    const [quotation, setQuotation] = useState({
        // channel_code: 2,
        type: "advanced",
        tax: "receiver",
        object: "not_doc",
        insurance: false,
        currency_quote: "BRL",
        currency_payment: "BRL",
    });
    const [change, setChange] = useState(date.getTime());

    function notifyChange() {
        setChange(date.getTime());
    }
    useEffect(() => {
        loadICMS();
        loadProfit();
        loadServiceNames();
        // if (enviroment == "staging" || enviroment == "local") {
        //     setData({
        //         origin: {
        //             "country_code": "DE",
        //             "postal_code": "21079",
        //             "residential": false,
        //             "country": "DE",
        //             "zipCode": "21079",
        //             "state": "HH",
        //             "city": "Hamburgo",
        //             "addressLine1": "21079 Hamburgo-Harburg, Alemanha",
        //             "addressLine2": " Harburg, Hamburgo,",
        //             "name": "Socorros",
        //             "state_code": "HH"
        //         },
        //         destination: {
        //             "country_code": "BR",
        //             "residential": true,
        //             "country": "BR",
        //             "zipCode": "06124190",
        //             "addressLine1": "R. Joaquim Félix Ribeiro - Vila Yolanda, Osasco - SP, 06124-190, Brasil",
        //             "addressLine2": "R. Joaquim Félix Ribeiro, Vila Yolanda, Osasco, SP,",
        //             "state": "SP",
        //             "city": "Osasco",
        //             "name": "Socorro",
        //             "state_code": "SP"
        //         },
        //         boxes: [{
        //             "id": 1,
        //             "name": "Bolsas",
        //             "height": 10,
        //             "width": 20,
        //             "depth": 30,
        //             "weight": 1,
        //             "price": 100,
        //             "items": [
        //                 {
        //                     countryCode: "DE",
        //                     country: "DE",
        //                     country_code: "DE",
        //                     description: "Hummer",
        //                     hscode: "902300",
        //                     name: "Martelo",
        //                     quantity: 1,
        //                     unitValue: 100,
        //                     unit_value: 100,
        //                     weight: 1,
        //                     boxId: "1",
        //                     box_id: "1",
        //                     id: 1,
        //                 }
        //             ]
        //         }]
        //     });

        //     setResponsibles({
        //         collect: {
        //             name: "Fabio Rodrigues",
        //             responsibleName: "Fabio Rodrigues",
        //             email: "fabiorsilvajr@gmail.com",
        //             phone: "991315267",
        //             document: "43060160805",
        //         },
        //         delivery: {
        //             name: "Fabio Rodrigues",
        //             responsibleName: "Fabio Rodrigues",
        //             email: "fabiorsilvajr@gmail.com",
        //             phone: "991315267",
        //             document: "43060160805",
        //         }
        //     })
        // }
        loadAddressBook()
        loadDelivery()
    }, []);

    function loadDelivery() {
        if (props != undefined && props.location != undefined) {

            let param = props.location.search;
            let deliveryId = "";
            if (param.split("?")[1] !== undefined) {

                let item = param.split("?")[1].split("&"),
                    returnBool = false;
                for (var i = 0; i < item.length; i++) {
                    let parr = item[i].split("=");
                    if (parr[0] == "deliveryId" && parr[0] != undefined) {
                        deliveryId = decodeURIComponent(parr[1]);
                    }
                }



                let infos = data;
                if (deliveryId != undefined && deliveryId != null) {
                    DeliveryController.GetOne(deliveryId, res => {
                        res.origin.country = res.origin.country;
                        res.destination.country = res.destination.country;
                        res.origin.address = `${res.origin.number}, ${res.origin.street}, ${res.origin.neighborhood} | ${res.origin.city} - ${res.origin.state}`;
                        res.destination.address = `${res.destination.number}, ${res.destination.street}, ${res.destination.neighborhood} | ${res.destination.city} - ${res.destination.state}`;

                        for (let s in res.boxes) {
                            res.boxes[s].id = parseInt(s) + 1;
                            for (let t in res.boxes[s].items) {
                                res.boxes[s].items[t].box_id = res.boxes[s].id;
                                res.boxes[s].items[t].boxId = res.boxes[s].id;
                                res.boxes[s].items[t].country_code = res.boxes[s].items[t].countryCode;
                                res.boxes[s].items[t].country = res.boxes[s].items[t].countryCode;
                                res.boxes[s].items[t].unit_value = res.boxes[s].items[t].unitValue;
                                res.boxes[s].items[t].id = parseInt(t) + 1;
                            }
                        }


                        setData(res);
                        let responsible = {
                            collect: res.origin,
                            delivery: res.destination,
                        };
                        setResponsibles(responsible);
                    })
                }
            }
        }
    }

    function loadAddressBook() {
        AddressBookController.Get(res => setAddressBook(res))
    }

    function loadICMS() {
        ICMSController.List(res => setICMS(res))
    }

    function loadProfit() {
        ProfitController.List(async (res) => {
            let list = [];
            for (let s in res) {
                list.push(res[s]);
            }

            await CustomMarginController.ByUser(userData.id, result => {
                for (let s in result) {
                    list.push(result[s]);
                }
            })

            if (userData.companyId) {
                await CustomMarginController.ByCompany(userData.companyId, baseResult => {
                    for (let s in baseResult) {
                        list.push(baseResult[s]);
                    }
                })
            }



            setProfit(list);
        })
    }

    function loadServiceNames() {
        ServiceNameController.List(res => setNames(res))
    }

    function handleQuotationChange(evt, type) {
        if (evt.target.value == "doc" || evt.target.value == "not_doc") {
            if (data.origin == data.destination && data.destination == "BR") {
                setQuotation({
                    ...quotation,
                    [evt.target.name]: evt.target.value,
                    type: "simple",
                })
            } else {
                setQuotation({
                    ...quotation,
                    [evt.target.name]: evt.target.value,
                    type: evt.target.value == "doc" ? "simple" : "advanced",
                })
            }
        } else {
            setQuotation(OnDataChange(quotation, evt, type));
        }
    }

    function getQuotation(theData) {
        let base = theData;

        setNational([]);
        setInternational([]);
        setLoading(true)
        if (base.origin.country_code == "BR" && base.destination.country_code == "BR") {
            // TotalExpress - Entrega nacional
            getNationalQuotation(base)
        } else {
            // ShipSmart - Entrega internacional
            base.origin.state = base.origin.state;
            base.origin.state_code = base.origin.state;
            base.destination.state = base.destination.state;
            base.destination.state_code = base.destination.state;
            getInternationalQuotation(base)
        }
    }

    async function getNationalQuotation(baseQuotation) {
        let message = "Faltou preencher ";
        let error = false;
        let box = baseQuotation.boxes[0];
        box.declaredValue = box.price;
        if (box.height == undefined || box.height == "") {
            error = true;
            message += " Altura;"
        }
        if (box.width == undefined || box.width == "") {
            error = true;
            message += " largura;"
        }
        if (box.depth == undefined || box.depth == "") {
            error = true;
            message += " profundidade;"
        }
        if (box.weight == undefined || box.weight == "") {
            error = true;
            message += " peso;"
        }
        if (box.declaredValue == undefined || box.declaredValue == "") {
            error = true;
            message += " valor do conteúdo";
        }

        if (error) {
            toast.error(message);
        } else {
            let base = {};

            base.declaredValue = box.declaredValue;
            base.depth = box.depth;
            base.height = box.height;
            base.width = box.width;
            base.weight = box.weight;
            base.zipCode = data.destination.zipCode.replace(/\D/g, "");
            base.state = data.destination.state;
            const tax = ICMS.filter(x => x.originState == data.origin.state && data.destination.state == x.destinationState);

            TotalExpressController.Quotation(base, async res => {

                const today = new Date();
                const delivery = new Date(today.setDate(today.getDate() + res.deadline));

                const base = CalculoICMS(tax[0], res.beforeTaxes);
                res.totalPrice = base.total;
                res.taxCost = base.taxCost;

                let nationalName = names.filter(x => x.partner == 2);

                if (nationalName.length > 0) {
                    res.name = nationalName[0].name;
                } else {
                    res.name = "Total Express";
                }

                res.deliveryDate = OnlyDateTranslate(delivery);
                if (date.getHours() > 10) {
                    res.collectDate = "Coleta: Amanhã entre as 12 e 18h";
                } else {
                    res.collectDate = "Coleta: Hoje até as 18h";
                }

                let results = []
                res.partner = PartnerHelper.Partner.TotalExpress;
                if (data.origin.address.includes("GRU") || data.origin.address.includes("Aeroporto Internacional") || data.origin.address.includes("hélio schmidt"))
                    results.push(res);

                let parametrosProduto = [];
                for (let s in baseQuotation.boxes) {
                    const item = baseQuotation.boxes[s];
                    let baseCorreios = CorreiosController.BaseQuotation.parametrosProduto;

                    baseCorreios.comprimento = `${item.depth}`;
                    baseCorreios.altura = `${item.height}`;
                    baseCorreios.largura = `${item.width}`;
                    baseCorreios.psObjeto = `${item.weight}`;
                    baseCorreios.cepOrigem = data.origin.zipCode;
                    baseCorreios.cepDestino = data.destination.zipCode;

                    parametrosProduto.push(baseCorreios);

                }
                for (let s in correiosServices) {
                    let service = correiosServices[s];

                    let produto = [];

                    for (let p in parametrosProduto) {
                        parametrosProduto[p].coProduto = service.codigo;
                        produto.push(parametrosProduto[p]);
                    }

                    await CorreiosController.Quotation({ idLote: "sdklcsldc", parametrosProduto: produto }, result => {

                        let component = result[0];
                        if (component.pcFinal != "0.00") {


                            const margin = profit.filter(x => x.isDefault == true || x.country == "BR" || x.isDefault == undefined);

                            component.name = service.descricao;
                            component.collectDate = undefined;
                            component.deliveryDate = undefined;

                            component.taxCost = parseFloat(component.vlBaseCalculoImposto) - parseFloat(component.pcBase);

                            component.beforeTaxes = parseFloat(component.pcFinal);


                            let pretotal = parseFloat(component.pcFinal) + (margin[0].value * parseFloat(component.pcFinal));


                            component.total = pretotal;
                            const base = CalculoICMS(tax[0], pretotal);
                            component.totalPrice = base.total;
                            component.taxCost = base.taxCost;

                            component.freight = pretotal;
                            component.insurance = parseFloat(component.peAdValorem);
                            component.serviceValue = parseFloat(component.vlSeguroAutomatico);


                            let nationalName = names.filter(x => x.oldName == component.name);

                            if (nationalName.length > 0) {
                                component.name = nationalName[0].name;
                            }
                            results.push({ ...component, partner: PartnerHelper.Partner.Correios })

                            setNational(results);
                        }
                    }, error => console.log("Erro correios", error)
                    )
                }
                setLoading(false)
                setNational(results);
                setStep(3);

            });


        }
    }

    async function getInternationalQuotation(old) {
        let message = "Faltou preencher ";
        let error = false;
        let boxes = old.boxes;
        if (boxes.length == 0) {
            error = true;
            message += " Cadastrar ao menos uma caixa;"
        }

        if (error) {
            toast.error(message);
        } else {
            let items = [];
            for (let s in boxes) {
                if (boxes[s].items) {
                    items = [...items, ...boxes[s].items]
                }
            }

            let base = {
                ...quotation,
                currency_quote: CurrencyConverter(Storage.getCurrency()),
                address_sender: {
                    country_code: data.origin.country,
                    postal_code: data.origin.zipCode,
                    ...data.origin,
                },
                address_receiver: {
                    country_code: data.destination.country,
                    ...data.destination,
                },
                boxes,
                items,
            };


            if (data.origin.postal_town) {
                base.address_sender = data.origin.postal_town;
            }

            if (data.destination.postal_town) {
                base.address_receiver = data.destination.postal_town;
            }

            // address_code: 72,


            let carriers = [];
            const quotFedex = FedexController.Normalize(quotation, { ...data, boxes });
            await FedexController.Quotation(quotFedex, result => {
                if (result.output && result.output.rateReplyDetails) {
                    for (let s in result.output.rateReplyDetails) {

                        const service = result.output.rateReplyDetails[s];

                        let details = {};
                        let tax = 0;
                        let rate = 0;

                        for (let y in service.ratedShipmentDetails) {
                            if (service.ratedShipmentDetails[y].rateType == "ACCOUNT") {
                                tax = service.ratedShipmentDetails[y].totalDutiesTaxesAndFees;
                                rate = service.ratedShipmentDetails[y].shipmentRateDetail.currencyExchangeRate.rate;
                            }

                            if (service.ratedShipmentDetails[y].rateType == "PREFERRED_CURRENCY" || service.ratedShipmentDetails[y].currency == quotFedex.requestedShipment.preferredCurrency) {
                                details = service.ratedShipmentDetails[y];
                            }
                        }

                        if (service.ratedShipmentDetails.length == 1 && details.type == undefined) {
                            details = service.ratedShipmentDetails[0];
                            details.totalDutiesAndTaxes = tax;
                        }

                        console.log("Nem tentou", base.currency_quote)
                        if (base.currency_quote != "BRL") {
                            details.totalDutiesAndTaxes = tax / rate;
                            console.log("Dividiu o valor", tax / rate, tax, rate)
                        }

                        // if (details.currency != "BRL") {
                        //     let basePrice = details.shipmentRateDetail.currencyExchangeRate;
                        //     if (basePrice.fromCurrency == "BRL") {
                        //         details.totalDutiesAndTaxes = tax / basePrice.rate;
                        //         // rate = basePrice.rate;
                        //         console.log("calculei do dolar", details.totalDutiesAndTaxes, tax, basePrice.rate);
                        //     } else if (basePrice.fromCurrency == "USD") {
                        //         details.totalDutiesAndTaxes = tax;
                        //         // rate = basePrice.rate;
                        //         console.log("calculei do real", details.totalDutiesAndTaxes, tax, basePrice.rate);
                        //     }
                        // }

                        let body = {
                            quotationId: result.transactionId,
                            transactionId: result.transactionId,
                            name: DeliveryHelper().GetName(names, service.serviceName),
                            packagingType: service.packagingType,
                            deliveryStation: service.deliveryStation,
                            freight_final: ProcessProfit(profit, details.totalNetCharge, data.origin.country),
                            totalPrice: ProcessProfit(profit, details.totalNetCharge, data.origin.country),
                            customTotalPrice: ProcessProfit(profit, details.totalNetCharge, data.origin.country),
                            currency_quote_price: ProcessProfit(profit, details.totalNetCharge, data.origin.country),
                            currency_payment_amount: details.totalNetChargeWithDutiesAndTaxes,
                            price: details.totalNetCharge,
                            insurance: 0,
                            insurance_final: 0,
                            taxCost: details.totalDutiesAndTaxes,
                            tax_final: details.totalDutiesAndTaxes,
                            partner: PartnerHelper.Partner.Fedex,
                            fedexServiceType: service.serviceType,
                            packagingType: service.packagingType,
                            pickupType: "DROPOFF_AT_FEDEX_LOCATION",
                            currencyRate: rate,
                        }

                        if (service.operationalDetail && service.operationalDetail.deliveryDate != "0001-01-01T00:00:00") {
                            body.transit_days = Datediff(DateTimeNow(), service.operationalDetail.deliveryDate);
                        } else {
                        }

                        carriers.push(body);
                    }
                }
            }, error => {
                if (error && error.response && error.response.data && error.response.data.errors) {
                    for (let s in error.response.data.errors) {
                        const item = error.response.data.errors[s];

                        if (item && item.code == "CARRIAGEVALUE.EXCEEDS.CUSTOMVALUE") {
                            toast.error("O valor da(s) caixa(s) excedem o valor dos produtos");
                        }
                    }
                }
            })

            if (base.object == "doc") {
                delete base.items;
            }
            await ShipSmartController.Quotation(base, async (res) => {

                if (res.data) {
                    for (let s in res.data.carriers) {
                        let item = res.data.carriers[s];
                        res.data.carriers[s].quotationId = res.data.quotation;
                        res.data.carriers[s].name = DeliveryHelper().GetName(names, item.name);
                        res.data.carriers[s].freight_final = ProcessProfit(profit, parseFloat(res.data.carriers[s].freight_final), data.origin.country);
                        res.data.carriers[s].totalPrice = ProcessProfit(profit, parseFloat(res.data.carriers[s].freight_final), data.origin.country);
                        res.data.carriers[s].price = ProcessProfit(profit, parseFloat(res.data.carriers[s].freight_final), data.origin.country);
                        res.data.carriers[s].customTotalPrice = ProcessProfit(profit, parseFloat(res.data.carriers[s].freight_final), data.origin.country);
                        res.data.carriers[s].currency_quote_price = ProcessProfit(profit, parseFloat(res.data.carriers[s].currency_quote_price), data.origin.country);
                        res.data.carriers[s].currency_payment_amount = ProcessProfit(profit, parseFloat(res.data.carriers[s].currency_payment_amount), data.origin.country);
                        res.data.carriers[s].insurance = ProcessProfit(profit, parseFloat(res.data.carriers[s].insurance), data.origin.country);
                        res.data.carriers[s].insurance_final = ProcessProfit(profit, parseFloat(res.data.carriers[s].insurance_final), data.origin.country);
                        res.data.carriers[s].partner = PartnerHelper.Partner.Shipsmart;
                        // ProcessProfit(profit, details.totalNetCharge, data.origin.country)

                        carriers.push(res.data.carriers[s]);
                    }
                }


            }, error => {

                if (error && error.response && error.response.data && error.response.data) {
                    for (let s in error.response.data) {
                        const item = error.response.data[s];
                        // toast.error(item[0].message);
                    }

                    if (error && error.response && error.response.data && error.response.data.errors) {
                        for (let s in error.response.data.errors) {
                            const item = error.response.data.errors[s];

                            if (item && item.code == "CARRIAGEVALUE.EXCEEDS.CUSTOMVALUE") {
                                toast.error("O valor da(s) caixa(s) excedem o valor dos produtos");
                            }
                        }
                    }
                } else {
                    toast.error(HandleErrors(error));
                }
            });

            /*
            const ratesObj = MyDhlController.Normalize(data);
            await MyDhlController.RatesForMultiplePieceShipment(ratesObj, result => {
                // Products: `result.products`
                // Exchange rates: `result.exchangeRates`
                for (let product of result.products) {
                    /// Price currencies (priceCurrency): 
                    /// Exemplo: "USD" "BRL", "EUR",

                    /// Currency types (currencyType):
                    /// BILLC = billing currency
                    /// PULCL = country public rates currency
                    /// BASEC = base currency

                    // Obter o preço através do `currencyType`
                    const currencyType = "BILLC";
                    const pTotalPrice = product.totalPrice.find((tp) => tp.currencyType === currencyType);
                    const pTotalPriceBreakdown = product.pTotalPriceBreakdown.find((tp) => tp.currencyType === currencyType);
                    const pDetailedPriceBreakdown = product.pDetailedPriceBreakdown.find((dp) => dp.currencyType === currencyType);

                    // Obter o preço através do `priceCurrency`
                    // const priceCurrency = "BRL";
                    // const pTotalPrice = product.totalPrice.find((tp) => tp.priceCurrency === priceCurrency);
                    // const pTotalPriceBreakdown = product.pTotalPriceBreakdown.find((tp) => tp.priceCurrency === priceCurrency);
                    // const pDetailedPriceBreakdown = product.pDetailedPriceBreakdown.find((dp) => dp.priceCurrency === priceCurrency);

                    let totalTax = 0;
                    pDetailedPriceBreakdown.breakdown.forEach(item => {
                        if (item.priceBreakdown && Array.isArray(item.priceBreakdown)) {
                            item.priceBreakdown.forEach(pb => {
                                if (pb.priceType === "TAX" && pb.price) {
                                    totalTax += pb.price;
                                }
                            });
                        }
                    });

                    let discount = 0;
                    pDetailedPriceBreakdown.breakdown.forEach(item => {
                        if (item.priceBreakdown && Array.isArray(item.priceBreakdown)) {
                            item.priceBreakdown.forEach(pb => {
                                if (pb.priceType === "DISCOUNT" && pb.price) {
                                    discount += pb.price;
                                }
                            });
                        }
                    });

                    // Mais informações em `pickupCapabilities` e `deliveryCapabilities`:
                    // product.pickupCapabilities
                    // product.deliveryCapabilities

                    let newItem = {
                        partner: PartnerHelper.Partner.MyDhl,
                        name: product.productName,
                        price: pTotalPrice.price,
                        totalPrice: ProcessProfit(profit, pTotalPrice.price, data.origin.country),
                        customTotalPrice: ProcessProfit(profit, pTotalPrice.price, data.origin.country),

                        freight_final: ProcessProfit(profit, pTotalPrice.price, data.origin.country),
                        currency_quote_price: ProcessProfit(profit, pTotalPrice.price, data.origin.country),
                        insurance: 0,
                        insurance_final: 0,
                        taxCost: totalTax,
                        tax_final: totalTax,
                        currency_payment_amount: pTotalPrice.price,
                        transit_days: product.deliveryCapabilities.totalTransitDays,

                        //deliveryStation: service.deliveryStation,
                        //currencyRate: rate,
                    };

                    for (let exchangeRate in result.exchangeRates) {
                        newItem.currencyRate = exchangeRate.currentExchangeRate;
                        break;
                    }

                    carriers.push(newItem);
                }
            }, error => {
                toast.error(HandleErrors(error));
            });
            */

            const carriersResponse = carriers.sort(function (a, b) {
                return a.price - b.price;
            });

            setInternational(carriersResponse);
            setLoading(false)
            setStep(3);
        }
    }

    function reportAddresses(address) {
        setData({ ...data, ...address })
        setStep(step + 1);
        if (address.origin.country_code == "BR" && address.destination.country_code == "BR") {
            loadCorreiosService()
        }


    }

    function loadCorreiosService() {
        CorreiosController.Servicos(res => {
            if (res.itens != undefined && res.itens.length > 0) {
                setCorreiosServices(res.itens.filter(x => x.descSegmento == "ENCOMENDA"));
            }
        })
    }

    function reportBoxes(boxes, goFoward) {
        console.log("Caixa", boxes, data);
        for (let s in boxes) {
            if (quotation.object == "doc") {
                boxes[s].type = 1;
            } else {
                boxes[s].type = 2;
            }
        }
        setData({ ...data, boxes })

        if (goFoward == true) {
            setStep(step + 1);
            getQuotation({ ...data, boxes });
        }
    }

    function selectedNational(selected) {
        const today = new Date();
        const delivery = new Date(today.setDate(today.getDate() + selected.deadline));

        selected.deliveryDate = DateTranslate(delivery);
        if (date.getHours() > 10) {
            selected.collectDate = "Coleta: Amanhã entre as 12 e 18h";
        } else {
            selected.collectDate = "Coleta: Hoje até as 18h";
        }
        setNationalCarrier(selected);
        setStep(step + 1)
    }

    function selectedInternational(selected) {
        console.log("Coleta selecionada", selected, data);
        selected.object = quotation.object;
        setInternationalCarrier(selected);
        setStep(step + 1)
    }

    function reportOriginResponsible(item) {
        setResponsibles({ ...responsibles, collect: item });
    }

    function reportDestinationResponsible(item) {
        setResponsibles({ ...responsibles, delivery: item });
    }

    function handleStep() {
        switch (step) {
            case 1:
                return (
                    <div className="row">
                        <div className="col-md-12">
                            <InternationalAddressStep
                                infos={data}
                                addressBook={addressBook}
                                reportOriginResponsible={item => reportOriginResponsible(item)}
                                reportDestinationResponsible={item => reportDestinationResponsible(item)}
                                reportAddresses={address => reportAddresses(address)} />
                        </div>
                    </div>
                )
            case 2:
                return (
                    <div>
                        <div className="row">
                            <div className="block block-rounded block-bordered block-fx-pop ml-0 mr-0 border-info col-md-12">
                                <div className="block-header">
                                    <div className="block-title"><i className="fa fa-book mr-2 text-info" /> {Translate(Message.CustomsDefinitions)}</div>
                                </div>
                                <div className="ml-2 mr-2 mb-3">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <span>{Translate(Message.Insurance)}</span>
                                            <select className="form-control" name="insurance" value={quotation && quotation.insurance} onChange={evt => handleQuotationChange(evt, FieldTypeObj.Bool)}>
                                                <option>{Translate(Message.Select)}</option>
                                                <option value={true}>{Translate(Message.Yes)}</option>
                                                <option value={false}>{Translate(Message.No)}</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{Translate(Message.WhosGonaPaysTaxes)}</span>
                                            <select className="form-control" name="tax" value={quotation && quotation.tax} onChange={evt => handleQuotationChange(evt)}>
                                                <option>{Translate(Message.Select)}</option>
                                                <option value={"sender"}>{Translate(Message.Sender)}</option>
                                                <option value={"receiver"}>{Translate(Message.Recipient)}</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <span>{Translate(Message.ProductType)}</span>
                                            <select className="form-control" name="object" value={quotation && quotation.object} onChange={evt => handleQuotationChange(evt)}>
                                                <option>{Translate(Message.Select)}</option>
                                                <option value={"doc"}>Documento</option>
                                                <option value={"not_doc"}>Produto</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {quotation &&
                            <BoxesStep reportBoxes={(boxes, goFoward) => reportBoxes(boxes, goFoward)} infos={data} goBack={() => setStep(step - 1)} quotation={quotation && quotation} />
                        }
                    </div>
                )
            case 3:
                return (
                    <div className="">
                        {loading === true ? (
                            <div className="block-content text-center">
                                <i className={"fa fa-circle-notch fa-spin"}></i>
                            </div>
                        ) : ""}
                        <QuotationStep
                            infos={data}
                            international={international}
                            national={national}
                            goBack={() => setStep(step - 1)}
                            selectedNational={selected => selectedNational(selected)}
                            selectedInternational={selected => selectedInternational(selected)} />
                    </div>
                )
            case 4:
                return (
                    <div className="row">
                        <ConfirmationStep
                            infos={data}
                            back={() => setStep(step - 1)}
                            end={() => setStep(step + 1)}
                            nationalCarrier={nationalCarrier}
                            internationalCarrier={internationalCarrier}
                            reportResponsibles={infos => setResponsibles(infos)}
                            responsibles={responsibles}
                            quotation={quotation}
                            reportItens={itens => setData({ ...data, ...itens })} />
                    </div>
                )
            case 5:
                return (
                    <div className="text-center">
                        <i className="si si-check fa-2x text-succcess" />
                        <br />
                        <h3 className="text-muted py-5">Seu pedido foi finalizado!<br /> A documentação sendo emitida</h3>

                        <div className="block block-bordered">
                            <button type="button" className="btn btn-hero-lg btn-hero-success mt-3" onClick={() => Functions.GoHome()}>
                                Voltar ao início
                            </button>
                        </div>
                    </div>
                )
            case 6:
                return (
                    <div className="text-center">
                        <i className="si si-check fa-2x text-succcess" />
                        <br />
                        <h3 className="text-muted py-5">Seu pedido foi finalizado!<br /> A documentação sendo emitida</h3>

                        <div className="block block-bordered">
                            <button type="button" className="btn btn-hero-lg btn-hero-success mt-3" onClick={() => Functions.GoHome()}>
                                Voltar ao início
                            </button>
                        </div>
                    </div>
                )
        }
    }

    return (
        <div className="p-2">
            <div className="" >
                <h3 className="text-muted cursor" style={{ width: 180 }} onClick={() => Functions.GoHome()}><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.Quotation)}</h3>
            </div>

            {step && handleStep()}
        </div>
    )
}